export const SALES = '/add-client/sales'
export const SALES_INFO = '/add-client/sales/info'
export const SALES_OFFERS = '/add-client/sales/offers'
export const SALES_BILLING = '/add-client/sales/billing'
export const SALES_SUMMARY = '/add-client/sales/summary'
export const SALES_APPOINTMENT = '/add-client/sales/appointment'
export const SALES_NEXT_STEPS = '/add-client/sales/next-steps'
